import React, { FC } from 'react'
import styled from 'styled-components'
import CalendarProvider from '../Provider/CalendarProvider'
import { SideMenu } from '../SideMenu'
import CalendarHeader from './CalendarHeader'
import DateTimetable from './TimeTable/DateTimetable'

const Calendar: FC = () => {
  return (
    <CalendarProvider>
      <TopMain>
        <SideMenu />
        <CalendarWrapper>
          <CalendarHeader />
          <DateTimetable />
        </CalendarWrapper>
      </TopMain>
    </CalendarProvider>
  )
}

export default Calendar

const TopMain = styled.div`
  * {
    box-sizing: border-box;
  }
  display: flex;
  height: calc(100vh /* - 86px*/);
  & .MuiPickersCalendarHeader-label {
    margin-right: 0;
  }
  & .MuiCalendarPicker-root {
    width: 300px;
    margin: 0;
  }
  & .MuiPickerStaticWrapper-content,
  .MuiCalendarOrClockPicker-root {
    width: 300px;
    min-width: 300px;
  }
  & .MuiCalendarOrClockPicker-root > div {
    width: 300px;
  }
  & .MuiPickersCalendarHeader-label {
    font-style: normal;
    font-weight: 600;
    font-size: 30px;
    line-height: 40px;
  }
  & .MuiPickersCalendarHeader-root {
    padding: 0 6px;
  }
`

const CalendarWrapper = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  flex: 1;
`
